"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CalendarGrid = _interopRequireDefault(require("../CalendarGrid"));
var _CalendarHeader = _interopRequireDefault(require("../CalendarHeader"));
var _utils = _interopRequireWildcard(require("../utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Calendar = function Calendar(_ref) {
  var data = _ref.data,
    onDateChanged = _ref.onDateChanged,
    enableDatesInPast = _ref.enableDatesInPast;
  var TODAY = new Date();
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDate = _useState2[0],
    setSelectedDate = _useState2[1];
  var _useState3 = (0, _react.useState)(TODAY.getMonth() + 1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentMonth = _useState4[0],
    setCurrentMonth = _useState4[1];
  var _useState5 = (0, _react.useState)(TODAY.getFullYear()),
    _useState6 = _slicedToArray(_useState5, 2),
    currentYear = _useState6[0],
    setCurrentYear = _useState6[1];

  // CORE functions *****
  var resolveStateFromDate = function resolveStateFromDate(date) {
    setSelectedDate(date);
    setCurrentMonth(+date.getMonth() + 1);
    setCurrentYear(date.getFullYear());
  };
  var getCalendarDates = function getCalendarDates() {
    var calendarMonth = currentMonth || +selectedDate.getMonth() + 1;
    var calendarYear = currentYear || selectedDate.getFullYear();
    return (0, _utils.default)(calendarMonth, calendarYear);
  };

  // EVENT HANDLERS ****
  var gotoDate = function gotoDate(date) {
    if (!(0, _utils.isSameDay)(date, selectedDate)) {
      onDateChanged(date.toDateString());
      resolveStateFromDate(date);
    }
  };
  var gotoPreviousMonth = function gotoPreviousMonth() {
    var newMonthAndYear = (0, _utils.getPreviousMonth)(currentMonth, currentYear);
    setCurrentMonth(newMonthAndYear.month);
    setCurrentYear(newMonthAndYear.year);
  };
  var gotoNextMonth = function gotoNextMonth() {
    var newMonthAndYear = (0, _utils.getNextMonth)(currentMonth, currentYear);
    setCurrentMonth(newMonthAndYear.month);
    setCurrentYear(newMonthAndYear.year);
  };
  var gotoPreviousYear = function gotoPreviousYear() {
    setCurrentYear(currentYear - 1);
  };
  var gotoNextYear = function gotoNextYear() {
    setCurrentYear(currentYear + 1);
  };
  var handlePrevious = function handlePrevious(evt) {
    evt === null || evt === void 0 ? void 0 : evt.preventDefault();
    evt.shiftKey ? gotoPreviousYear() : gotoPreviousMonth();
  };
  var handleNext = function handleNext(evt) {
    evt === null || evt === void 0 ? void 0 : evt.preventDefault();
    evt.shiftKey ? gotoNextYear() : gotoNextMonth();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendar-container"
  }, /*#__PURE__*/_react.default.createElement(_CalendarHeader.default, {
    month: currentMonth,
    year: currentYear,
    handleNext: handleNext,
    handlePrevious: handlePrevious
  }), /*#__PURE__*/_react.default.createElement(_CalendarGrid.default, {
    TODAY: TODAY,
    selectedDate: selectedDate,
    currentMonth: currentMonth,
    currentYear: currentYear,
    getCalendarDates: getCalendarDates,
    gotoDate: gotoDate,
    enableDatesInPast: enableDatesInPast
  }));
};
var _default = Calendar;
exports.default = _default;